import react from "react";
import { KpiCard } from "../../../Component/CustComponents/KpiCard";
import { AlertTriangle, CheckCircle2, FileText, HelpCircle, IndianRupee, ShieldCheck } from "lucide-react";
import { formatCurrency } from "../../../Component/CustComponents/formatCurrency";
import { SectionCard } from "../../../Component/CustComponents/SectionCard";
import { Badge } from "../../../Component/CustComponents/Badge";
import { useNavigate } from "react-router-dom";

export default function OverviewView({ stats }) {
  const navigate = useNavigate();

  return (
    <div
      className="
        space-y-4

        /* MOBILE GLASS CONTAINER */
        sm:bg-white/40
        sm:backdrop-blur-xl
        sm:rounded-3xl
        sm:p-4
        sm:shadow-xl

        /* DESKTOP RESET */
        md:bg-transparent
        md:backdrop-blur-0
        md:rounded-none
        md:p-0
        md:shadow-none
      "
    >
      {/* ================= KPI GRID ================= */}
      <div
        className="
          grid gap-3

          /* MOBILE */
          grid-cols-2

          /* TABLET */
          sm:grid-cols-3

          /* DESKTOP */
          md:grid-cols-5
        "
      >
        <KpiCard
          label="Active"
          value={stats.active}
          subLabel={`Total: ${stats.total}`}
          icon={ShieldCheck}
          onClick={() =>
            navigate("/custwarnty", { state: { filterStatus: "Active", fromKPI: true } })
          }
          className="
            sm:bg-white/60
            sm:backdrop-blur
            sm:rounded-2xl
            sm:shadow-md
          "
        />

        <KpiCard
          label="Expired"
          value={stats.expired}
          subLabel="No cover"
          icon={AlertTriangle}
          onClick={() =>
            navigate("/custwarnty", { state: { filterStatus: "Expired", fromKPI: true } })
          }
          className="sm:bg-white/60 sm:backdrop-blur sm:rounded-2xl sm:shadow-md"
        />

        <KpiCard
          label="Claims"
          value={stats.openClaims}
          subLabel="In process"
          icon={FileText}
          onClick={() =>
            navigate("/custclaims", { state: { filterStatus: "Approved", fromKPI: true } })
          }
          className="sm:bg-white/60 sm:backdrop-blur sm:rounded-2xl sm:shadow-md"
        />

        <KpiCard
          label="Settled"
          value={stats.settled}
          subLabel="Resolved"
          icon={CheckCircle2}
          className="sm:bg-white/60 sm:backdrop-blur sm:rounded-2xl sm:shadow-md"
        />

        <KpiCard
          label="Amount"
          value={`₹${formatCurrency(stats.totalApprovedAmount)}`}
          subLabel="Approved"
          icon={IndianRupee}
          className="sm:bg-white/60 sm:backdrop-blur sm:rounded-2xl sm:shadow-md"
        />
      </div>

      {/* ================= LAST CLAIM ================= */}
      <SectionCard
        title="Last Claim Status"
        className="
          sm:bg-white/60
          sm:backdrop-blur
          sm:rounded-3xl
          sm:shadow-lg

          md:bg-white
          md:rounded-xl
        "
      >
        {stats.lastClaim ? (
          <div className="text-xs space-y-3">
            <div className="flex justify-between gap-2">
              <div>
                <div className="font-semibold text-slate-800">
                  {stats.lastClaim.productName}
                </div>
                <div className="text-[11px] text-slate-500">
                  Claim ID: {stats.lastClaim.id}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[11px] text-slate-500">Raised</div>
                <div className="font-medium">{stats.lastClaim.raisedOn}</div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-[11px] text-slate-500">Status:</span>
              <Badge
                color={
                  stats.lastClaim.status === "Approved"
                    ? "green"
                    : stats.lastClaim.status === "Rejected"
                    ? "red"
                    : "yellow"
                }
              >
                {stats.lastClaim.status}
              </Badge>
            </div>

            <div className="text-[11px] text-slate-600">
              {stats.lastClaim.issueSummary}
            </div>

            {stats.lastClaim.adminMessage && (
              <div className="bg-blue-50/70 backdrop-blur rounded-xl p-2">
                <div className="text-[11px] font-semibold text-blue-700 flex items-center gap-1">
                  <HelpCircle className="w-3 h-3" />
                  Update from Support
                </div>
                <div className="text-[11px] text-blue-700 mt-1">
                  {stats.lastClaim.adminMessage}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="text-xs text-slate-500">
            No claims yet. Use the <b>Claims</b> tab to raise one.
          </div>
        )}
      </SectionCard>
    </div>
  );
}
